import React, { Component, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './fish.action';
import * as commonActions from '../../../../app/common/common.action';
import * as editorActions from '../../editor/editor.action';
import { acessoPermitido } from '../../../../acessos.seguranca';
import * as acessos from '../../../../acessos.const.util';
import * as editor from '../../editor/editor.util';
import { verificarPlainTextMudou } from '../../editor/editor.util';
import FishAPI from './fish.api';
import FishPage from './fish.page';
import { LOCAL_STORAGE_USUARIO } from '../../../../localStorage.util';
import WebapiCommon from '../../../../app/common/util/webapi.common';
import ProtocoloContainer from '../../../../app/common/protocolo/protocolo.container';
import ExamesEmAbertoContainer from '../../etapas/macroscopia/operacoes/exames/exames.container';
import { etapasEnum, statusEtapasEnum } from '@common/util/defaultValues';
import { errors } from '../../../error/erros';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { editorUrl } from '@constants/defaultValues';
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar';
import { urlImagemRadiologia } from '../etapas.common.util';

function FishContainer(props) {

  const [modalVisivel, setmodalVisivel] = useState(false);
  const [modalTitulo, setmodalTitulo] = useState('');
  const [modalSize, setmodalSize] = useState('lg');
  const [modalConteudo, setmodalConteudo] = useState(undefined);
  const [callbackAutorizar, setcallbackAutorizar] = useState(undefined);
  const [modalAutorizacaoLaudar, setmodalAutorizacaoLaudar] = useState(false);
  const [timeoutResize, settimeoutResize] = useState(null);
  const [showModalCancelamento, setshowModalCancelamento] = useState(false);
  const [justificativaCancelar, setjustificativaCancelar] = useState('');
  const [showModalConfirmarCancelamento, setshowModalConfirmarCancelamento] = useState(false);
  const [modalEncaminhar, setModalEncaminhar] = useState(false)
  const [modalEncaminharType, setModalEncaminharType] = useState('ok');
  const [modalConfirmar, setmodalConfirmar] = useState(false);
  const [modalConfirmarMensagem, setmodalConfirmarMensagem] = useState('');
  const [modalConfirmarType, setmodalConfirmarType] = useState('confirm');
  const [modalConfirmarClick, setmodalConfirmarClick] = useState(() => { });
  const [verificarTexto, setVerificarTexto] = useState(false);
  const [textoEditor, setTextoEditor] = useState('');
  const [existemImagemsRadiologia, setExistemImagensRadiologia] = useState(false);
  const history = useHistory();
  const intl = useIntl();

  function useForceUpdate() {
    const [value, setValue] = useState(0);
    return () => setValue(value + 1);
  }

  const handleResize = useForceUpdate();

  useEffect(() => {
    props.commonActions.alterarVisibilidadeAbas({});
    document.title = 'Anatomia Patológica';

    try {
      editor.Inicializar(props, etapasEnum.FISH.toLowerCase());
    } catch (error) {
      let message = error.message;
      let title = '';
      let origin = `Etapa: ${etapasEnum.FISH}`;
      const code = 101;

      errors.map(err => {
        if (err.code === code) {
          title = err.title;
        }
        return err;
      });
      window.location.replace(
        `/error/${btoa(title)}/${btoa(message)}/${btoa(code)}/${btoa(origin)}/`
      );
    }

    const laudarEtapaRequest = {
      pendente: true,
      notificacaoCancer: false,
      exameId: props.detalhes.exameId,
      medicoSolicitante: props.detalhes.idSolicitante,
      medicoEtapa: props.editor.medExecutante,
      medicoRevisor: props.editor.medRevisor,
    };

    props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);

    let etapa = props.detalhes.etapas.find(
      el => el.etapa.toLowerCase() === etapasEnum.FISH.toLowerCase()
    );
    props.actions.fishFinalizada(etapa.status === statusEtapasEnum.REALIZADO);
    window.addEventListener('resize', handleResize);

    return () => {
      editor.finalizar(props.commonActions);
      settimeoutResize(null)
    }
  }, []);

  useEffect(() => {
    WebapiCommon.verificarSeExistemImagensRadiologica(props.detalhes.acNumber, props.detalhes.prontuario).then((resultado) =>{
      setExistemImagensRadiologia(resultado);
      if (props.editorInicializado && resultado){
        props.commonActions.showAlerta('alerta',  intl.formatMessage({ id: "dashboards.examDetails.imagesVivaceConnect" }), 7000, '650px');
      }
    });
  }
  , [props.editorInicializado]);

  useEffect(() => {
    window.addEventListener('message', ({ data }) => {
      if (data.value) {
        if (data.value.plain) {
          setTextoEditor(data.value.plain);
        }
      }
    });

    return () => {
      window.removeEventListener('message', null, true);
      props.commonActions.mudarStatusLaudoFaturado(false);
    }

  }, []);

  useEffect(() => {
    if (textoEditor !== undefined && verificarTexto) {
      setVerificarTexto(false);
      props.commonActions.showFadeCarregando(true);
      if (!textoEditor || textoEditor.trim() === '') {
        props.commonActions.showFadeCarregando(false);
        return showModal('2');
      }else{
        return laudar(false, false);
      }
    }

  }, [textoEditor, verificarTexto]);

  function verificaEditor() {
    props.commonActions.showFadeCarregando(true);
    const frame = document.getElementById('iframe-editor');

    if (frame !== null) {
      frame.contentWindow.postMessage(
        {
          method: 'recuperarTextoRtfAndPlainText',
          urlHost: editorUrl,
          args: {
            action: 'getPlainText'
          }
        },
        editorUrl
      );
    }

    setTimeout(() => {
      props.commonActions.showFadeCarregando(false);
      return setVerificarTexto(true);
    }, 200);

  }

  function cancelarEtapasPosteriores() {
    props.commonActions.showFadeCarregando(true);
    const listagem = [...props.listagem];
    const listagemIndex = listagem.findIndex(
      (item) => item.laudo === props.detalhes.laudo
    );
    if (listagemIndex >= 0) {
      listagem[listagemIndex].dataLiberacao = '';
      listagem[listagemIndex].isLaudoLiberado = false;
      listagem[listagemIndex].isLiberadoParcial = false;
      listagem[listagemIndex].isLiberadoTotal = false;
      props.commonActions.preencherListagem(listagem);
    }
    WebapiCommon.cancelarEtapasPosteriores(
      props.detalhes.laudo,
      props.etapaAtual,
      0,
      justificativaCancelar
    )
      .then((resp) => {
        if (resp.success) {
          props.commonActions.showAlerta(
            'sucesso',
            resp.data.mensagem,
            2000
          );

          WebapiCommon.obterStatusEtapasLaudo(props.detalhes.laudo).then(
            (etapas) => {
              props.commonActions.atualizarStatusDasEtapasDoLaudo(
                etapas,
                props.detalhes.laudo
              );
              props.commonActions.showEditor(false);
              props.commonActions.showFadeCarregando(false);
              toggleModalCancelamento();
              setshowModalConfirmarCancelamento(false)
              _fechar();
            }
          )
        }
        else {
          props.commonActions.showFadeCarregando(false);
          props.commonActions.showAlerta(
            'erro',
            intl.formatMessage({id:"dashboards.examDetail.unableCancelSteps"}),
            2000
          );
          toggleModalCancelamento();
          setshowModalConfirmarCancelamento(false)

        }
      })
      .catch((error) => {
        props.commonActions.showFadeCarregando(false);
        props.commonActions.showAlerta(
          'erro',
          intl.formatMessage({id:"dashboards.examDetail.unableCancelSteps"}),
          2000
        );
        toggleModalCancelamento();
        toggleModalConfirmarCancelamento();
      });
  }


  function _fechar() {
    history.goBack();
    //props.commonActions.atualizarDetalhes(undefined);
    props.commonActions.preenhcerHistoricoInconformidades(undefined);
    props.commonActions.atualizarLarguraEditor('100%');
    props.commonActions.showEditor(false);
  }

  function cancelamentoFish() {
    setshowModalCancelamento(true)
    setshowModalConfirmarCancelamento(false)
  }

  function toggleModalCancelamento() {
    setshowModalCancelamento(false)
  }

  function cancelarFish() {
    props.commonActions.showFadeCarregando(true);
    const listagem = [...props.listagemCommon];
    const listagemIndex = listagem.findIndex(
      (item) => item.laudo === props.detalhes.laudo
    );
    if (listagemIndex >= 0) {
      listagem[listagemIndex].dataLiberacao = '';
      listagem[listagemIndex].isLaudoLiberado = false;
      listagem[listagemIndex].isLiberadoParcial = false;
      listagem[listagemIndex].isLiberadoTotal = false;
      props.commonActions.preencherListagem(listagem);
    }
    FishAPI.cancelamentoFish(
      props.detalhes.laudo,
      state.justificativaCancelar
    ).then(res => {
      WebapiCommon.obterStatusEtapasLaudo(props.detalhes.laudo).then(
        etapas => {
          props.commonActions.atualizarStatusDasEtapasDoLaudo(
            etapas,
            props.detalhes.laudo
          );
          props.commonActions.showEditor(false);
          props.commonActions.showFadeCarregando(false);
          toggleModalCancelamento();
          _fechar();
        }
      );
    });
  }

  function setJustificativa(texto) {
    setjustificativaCancelar(texto)
  }

  function alterarFullscreen() {
    props.commonActions.preencherAtalho('ctrl+alt+f10');
  }

  function showModal(index) {
    let componente = undefined;
    let titulo = '';
    let size = 'lg';

    switch (index) {
      case '1':
        size = 'xl'
        componente = <ProtocoloContainer />;
        titulo = intl.formatMessage({id:"dashboards.examDetail.requisitionReportProtocols"}) /* `${props.detalhes.laudo}`*/;
        break;
      case '2':
        setmodalConfirmarMensagem(intl.formatMessage({ id: "dashboards.examDetail.notTyped" }));
        setmodalConfirmarType('ok');
        return setmodalConfirmarClick(() => {
          setmodalConfirmar(!modalConfirmar);
        });
      case '3':
        componente = <ExamesEmAbertoContainer />;
        titulo = intl.formatMessage({ id: "dashboards.examDetails.openExamReport" });
        break;
      default:
        componente = undefined;
        break;
    }
    setmodalConteudo(componente);
    setmodalTitulo(titulo);
    setmodalVisivel(true);
    setmodalSize(size);
  }

  function closeModal() {
    setmodalVisivel(false)
  }

  const encaminharSegundaOpiniao = () => {
    setModalEncaminhar(!modalEncaminhar)
  }

  const fecharModalEncaminhar = () => {
    setModalEncaminhar(!modalEncaminhar);
  };

  function construirBotoes() {
    let botoes = [];

    botoes.push({
      backgroundColor: '#4375A3',
      className: 'mv-basico-imprimir',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.reports.printOut' }),
      onClick: () => editor.Imprimir(props.commonActions)
    });

    botoes.push({
      backgroundColor: '#3f8642',
      label: '2',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.referral.referral' }),
      onClick: () => encaminharSegundaOpiniao(),
    });

    if (acessoPermitido(props.usuario, acessos.ExamesEmAberto) && existemImagemsRadiologia) {
      botoes.push({
        backgroundColor: '#3c5d80',
        className: 'fas fa-eye',
        // label: 'Imagens',
        color: '#ffffff',
        texto: intl.formatMessage({ id: 'Vivace Connect' }),
        onClick: () => {
          urlImagemRadiologia(props.commonActions, props.detalhes.acNumber, props.detalhes.prontuario);
        },
      });
    }

    if (acessoPermitido(props.usuario, acessos.RequisicaoProtocolo) &&
      props.detalhes.existeBlocoCriado &&
      !props.fishFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        className: 'fas fa-eye-dropper',
        backgroundColor: '#f44336',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetails.protocolRequirements' }),
        onClick: () => {
          showModal('1');
        }
      });
    }

    if (acessoPermitido(props.usuario, acessos.ExamesEmAberto))
    {
      botoes.push({
        backgroundColor: '#17a2b8',
        className: 'fas fa-flask',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetails.openExams' }),
        totalizador: props.quantidadeLaudosEmAberto,
        onClick: () => {
          showModal('3');
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Fish) &&
      acessoPermitido(props.usuario, acessos.Concluir) &&
      !props.fishFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        backgroundColor: '#3f8642',
        className: 'fas fa-save',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.laud' }),
        onClick: () => {
          verificaEditor();
        },
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Fish) &&
      acessoPermitido(props.usuario, acessos.ConcluirPendente) &&
      !props.fishFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'far fa-save',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.laudPendent' }),
        onClick: () => {
          laudar(true, false);
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Fish) &&
      acessoPermitido(props.usuario, acessos.ConcluirConferencia) &&
      !props.fishFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'fas fa-file-signature',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.laudLecturer' }),
        // atalho: 'CTRL+ALT+P',
        onClick: () => {
          laudar(false, false, true);
        },
      });
    }


    if (
      acessoPermitido(props.usuario, acessos.CancelamentoFish) &&
      props.fishFinalizada
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'mv-basico-cancelar',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.Cancellation' }),
        atalho: 'CTRL+ALT+N',
        onClick: () => {
          setshowModalConfirmarCancelamento(!showModalConfirmarCancelamento);
        }
      });
    }

    botoes.push({
      backgroundColor: '#bbbbbb',
      label: 'F',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.examDetail.close' }),
      onClick: () => {
        fechar();
      }
    });

    return botoes;
  }

  function laudar(pendente, concluir, conferencia = false) {
    const usuarioLocal = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_USUARIO)
    );

    if (!usuarioLocal.medicoId && !pendente && !conferencia) {
      props.commonActions.showAlerta('erro', intl.formatMessage({id:"dashboards.examDetail.onlyDoctors" }), 2000);
      return;
    }
    let laudarEtapaRequest = {
      ...props.laudarEtapaRequest,
      pendente: pendente,
      concluirLaudo: concluir,
      medicoSolicitante: props.detalhes.solicitante,
      medicoEtapa: props.editor.medExecutante,
      medicoRevisor: props.editor.medRevisor,
      medicoLogadoId: usuarioLocal.medicoId,
      laudarParaConferencia: conferencia,
    };

    if (usuarioLocal.isResidente && !pendente && !conferencia) {
      setmodalAutorizacaoLaudar(true);
      setcallbackAutorizar({
        sucesso: medico_autorizou => {
          setmodalAutorizacaoLaudar(false);
          editarMedico(medico_autorizou);
          props.commonActions.argumentosSalvarEtapaLaudo(
            laudarEtapaRequest
          );
          editor.laudar(props.commonActions);
          props.commonActions.showAlerta(
            'sucesso',
            intl.formatMessage({id:"dashboards.examDetail.reportSave"}),
            2000
          );
        },
        error: () => {
          props.commonActions.showAlerta(
            'erro',
            intl.formatMessage({id:"dashboards.examDetail.notAllowed"}),
            2000
          );
        }
      })

    } else {
      props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);
      editor.laudar(props.commonActions);
      props.commonActions.showAlerta(
				'sucesso',
				intl.formatMessage({id:"dashboards.examDetail.reportSave"}),
				2000
			);
    }
  }

  function fechar() {
    props.commonActions.changeFecharTela(true);
    verificarPlainTextMudou();
  }

  function alterarVisibilidadeAbas(propriedadeNoEstado) {

    const visibilidade = !props[propriedadeNoEstado];
    const larguraEditor = visibilidade
      ? 'calc(100% - 33.333333% - 10px)'
      : '100%';
    props.commonActions.alterarVisibilidadeAbas({
      [propriedadeNoEstado]: visibilidade
    });
    props.commonActions.atualizarLarguraEditor(larguraEditor);
  }

  return (
    <React.Fragment>
    <ModalConfirmar
      toggleModalConfirmar={() =>
        setmodalConfirmar(!modalConfirmar)
      }
      type={modalConfirmarType}
      showModalConfirmar={modalConfirmar}
      titulo={`${intl.formatMessage({ id: "dashboards.examDetail.headsUp" })}`}
      mensagem={modalConfirmarMensagem}
      confirmar={modalConfirmarClick}
    />
    <FishPage
      toggleModalEncaminhar={() => setModalEncaminhar(!modalEncaminhar)}
      type={modalEncaminharType}
      showModalEncaminhar={modalEncaminhar}
      titulo={'Encaminhar'}
      mensagem={'Encaminhar'}
      confirmar={() => fecharModalEncaminhar()}
      laudo={props.detalhes.laudo}
      commonActions={props.commonActions}
      usuario={props.usuario}
      modalVisivel={modalVisivel}
      modalTitulo={modalTitulo}
      modalConteudo={modalConteudo}
      modalSize={modalSize}
      closeModal={(e) => closeModal(e)}
      detalhes={props.detalhes}
      construirBotoes={construirBotoes()}
      acessoPermitido={acessoPermitido}
      altura={window.innerHeight - props.altura - 214}
      alterarFullscreen={(e) => alterarFullscreen(e)}
      modalAutorizacaoLaudar={modalAutorizacaoLaudar}
      callbackAutorizar={callbackAutorizar}
      fecharModalAutorizacao={() =>
        setmodalAutorizacaoLaudar(false)
      }
      fishFinalizada={props.fishFinalizada}
      showModalCancelamento={showModalCancelamento}
      justificativaCancelar={justificativaCancelar}
      setJustificativa={(e) => setJustificativa(e)}
      toggleModalCancelamento={() => setshowModalCancelamento(!showModalCancelamento)}
      cancelarFish={(e) => cancelarFish(e)}
      showModalConfirmacaoCancelamento={(e) => cancelamentoFish(e)}
      modalIsOpen={showModalConfirmarCancelamento}
      toggleModalConfirmarCancelamento={() => setshowModalConfirmarCancelamento(!showModalConfirmarCancelamento)}
      cancelarEtapas={(e) => cancelarEtapasPosteriores(e)}
      alterarVisibilidadeAbas={(e) => alterarVisibilidadeAbas(e)}
      visibilidadeListaLaminas={props.visibilidadeListaLaminas}
      visibilidadeAutotexto={props.visibilidadeAutotexto}
      visibilidadeListagemAnexo={props.visibilidadeListagemAnexo}
      visibilidadeLaudosAnteriores={props.visibilidadeLaudosAnteriores}
      visibilidadeHistoricoLaudo={props.visibilidadeHistoricoLaudo}
      quantidadeLaudosAnteriores={props.quantidadeLaudosAnteriores}
    />
    </React.Fragment>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    editorActions: bindActionCreators(editorActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    usuario: state.usuario,
    altura: state.commonReducer.altura,
    editor: state.editor,
    detalhes: state.commonReducer.detalhes,
    editorCarregado: state.commonReducer.editorCarregado,
    laudarEtapaRequest: state.commonReducer.laudarEtapaRequest,
    listagem: state.commonReducer.listagem,
    exameFinalizado: state.commonReducer.exameFinalizado,
    existemImagemsRadiologia: state.commonReducer.existemImagemsRadiologia,
    fishFinalizada: state.fish.fishFinalizada,
    etapaAtual: state.commonReducer.etapa.etapa,
    visibilidadeListaLaminas: state.commonReducer.visibilidadeListaLaminas,
    visibilidadeAutotexto: state.commonReducer.visibilidadeAutotexto,
    visibilidadeLaudosAnteriores: state.commonReducer.visibilidadeLaudosAnteriores,
    visibilidadeListagemAnexo: state.commonReducer.visibilidadeListagemAnexo,
    visibilidadeHistoricoLaudo: state.commonReducer.visibilidadeHistoricoLaudo,
    quantidadeLaudosAnteriores: state.commonReducer.quantidadeLaudosAnteriores,
    quantidadeLaudosEmAberto: state.commonReducer.quantidadeLaudosEmAberto,
    editorInicializado: state.commonReducer.editorInicializado
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FishContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/fish/fish.container.js